import { Component, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ArenaCompetition } from '@sparro/app/core/models/competition.model';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'app-competition-bottomsheet',
  templateUrl: './competition-bottomsheet.component.html',
  styleUrls: ['./competition-bottomsheet.component.scss']
})
export class CompetitionBottomsheetComponent implements OnInit {
  competition: ArenaCompetition;
  modules = [];

  @ViewChildren('navLinks') links: QueryList<any>;
  @ViewChild('entryLink') entryLink: any;
  @ViewChild('discussionLink') discussionLink: any;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private router: Router,
    public _bottomSheetRef: MatBottomSheetRef<CompetitionBottomsheetComponent>
  ) {}

  ngOnInit(): void {
    this.modules = this.data.modules;
    this.competition = this.data.competition;
  }

  ngAfterViewInit() {
    if (this.router.url.includes('entries')) {
      this.entryLink._element.nativeElement.classList.add('active-route');
    } else if (this.router.url.includes('discussions')) {
      this.discussionLink._element.nativeElement.classList.add('active-route');
    } else {
      const currentUrlArray = this.router.url.split('/')[3];
      this.links.toArray().map(link => {
        const path = link._element.nativeElement.innerText.includes('&')
          ? link._element.nativeElement.innerText
              .replaceAll('&', '-')
              .toLowerCase()
              .replaceAll(' ', '')
          : link._element.nativeElement.innerText.trim().includes(' ')
          ? link._element.nativeElement.innerText.trim().replaceAll(' ', '-').toLowerCase()
          : link._element.nativeElement.innerText.toLowerCase();
        if (path === currentUrlArray) {
          link._element.nativeElement.classList.add('active-route');
        } else {
          link._element.nativeElement.classList.remove('active-route');
        }
      });
    }
  }

  getNavLink(module, type: 'std' | 'custom' = 'std', custom: string = ''): string {
    if (type === 'std') {
      let url =
        module[0].title == 'Jury' && module[0]?.people == 0
          ? `${environment.aboutUrl}about/jurors`
          : `${environment.competitionUrl}${this.competition.slug}/${module[0].type}/${module[0].slug}`;
      return url;
    } else {
      return `${environment.competitionUrl}${this.competition.slug}/${custom}`;
    }
  }
}
